import type { FaireProductEntity } from "../../entity_types/product";

export const p_zvqfh55qrr: FaireProductEntity = {
  token: "p_zvqfh55qrr",
  type: "product",
  name: "Rap Snacks Oowee Wildberry Worms (5.3oz) (12-Pack)",
  brandToken: "b_qvgnvkj5hp",
  brandName: "AI Distribution",
  imageUrl: "https://cdn.faire.com/fastly/16c632f6007bddc7d3204b0008055bb53c5dc707ed10ab5dd40b3e357535c5ae.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c5d2a9514852831152f19782d8df56b14896a3cd8cc898e9e9ce0b75276a2312.png"
  ],
  priceDollars: 23.54,
  description: "Rap Snacks Oowee Wildberry Worms bring a sophisticated twist to traditional gummy candies by infusing them with a rich blend of wildberry flavors. Each 5.3 oz bag offers a perfectly balanced chewy texture that enhances the vibrant, tangy-sweet taste, making them an excellent choice for both casual snacking and sharing at social events. This 12-bag set provides ample supply for extended enjoyment or group occasions, crafted with quality ingredients to ensure consistent flavor and satisfaction. These gummy worms stand out as a premium candy option for those who appreciate bold, innovative berry-infused treats.\n\n(12) Pack – Oowee Wildberry Worms, 5.3oz each.",
  tags: [],
  msrpDollars: 47.1,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:08:15.646Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
